var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "header", class: _vm.isMenuOpened ? "header_opened" : "" },
    [
      _c("header", { staticClass: "header__app" }, [
        _c("div", { staticClass: "section" }, [
          _c("div", { staticClass: "header__row" }, [
            _c("a", {
              staticClass: "header__logo",
              attrs: { href: "/" },
              domProps: { innerHTML: _vm._s(require("../img/logo.svg")) },
            }),
            _vm._v(" "),
            _c("div", { staticClass: "header__controls" }, [
              _c(
                "a",
                {
                  staticClass: "header__lang",
                  attrs: { href: _vm.localeLink },
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm.locales[this.$i18n.locale === "en" ? "ru" : "en"]
                    )
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "header__download",
                  attrs: {
                    href: _vm.$t("header.downloadLink"),
                    target: "_blank",
                  },
                },
                [
                  _c("div", { staticClass: "header__download-container" }, [
                    _c("div", {
                      staticClass: "header__download-img",
                      domProps: {
                        innerHTML: _vm._s(require("../img/download.svg")),
                      },
                    }),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "header__download-text",
                      domProps: {
                        textContent: _vm._s(_vm.$t("header.download")),
                      },
                    }),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "header__share" }, [
                _c("div", { staticClass: "header__share-container" }, [
                  _c("div", {
                    staticClass: "header__share-img",
                    domProps: {
                      innerHTML: _vm._s(require("../img/share.svg")),
                    },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "header__share-text" }, [
                    _c(
                      "div",
                      { staticClass: "header__share-text-share" },
                      [
                        _c("yandex-share", {
                          attrs: {
                            services: [
                              "twitter",
                              "linkedin",
                              "telegram",
                              "whatsapp",
                            ],
                            vertical: false,
                            small: true,
                            counter: "",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "header__share-text-custom",
                        attrs: { title: "Email" },
                      },
                      [
                        _c(
                          "a",
                          {
                            staticClass:
                              "header__share-item header__share-item_email",
                            attrs: { href: _vm.$t("header.mailTo") },
                          },
                          [_c("span")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "header__share-item header__share-item_copy",
                            attrs: { title: _vm.$t("header.copy") },
                            on: {
                              click: function ($event) {
                                return _vm.copyUrl()
                              },
                            },
                          },
                          [_c("span")]
                        ),
                      ]
                    ),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "header__burger",
                  class: _vm.isMenuOpened ? "header__burger_active" : "",
                  on: {
                    click: function ($event) {
                      return _vm.toggleMenu()
                    },
                  },
                },
                [_c("span"), _vm._v(" "), _c("span"), _vm._v(" "), _c("span")]
              ),
            ]),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }